import { useEffect } from "react";
import { formatTitle } from "util/helper";
import classes from "./BlogPostContent.module.css";

const createScriptForInstagram = () => {
  const script = document.createElement("script");
  script.type = "text/javascript";

  var attr = document.createAttribute("src");
  attr.value = "//www.instagram.com/embed.js";
  script.setAttributeNode(attr);

  const head = document.getElementsByTagName("head")[0];
  head.appendChild(script);
};

const BlogPostContent = (props) => {
  const { blogPost } = props;
  let dispDate = null;
  if (blogPost) {
    dispDate = blogPost.date.split("T")[0];
  }

  useEffect(() => {
    createScriptForInstagram();

    // run code after rendering instagram script
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, [blogPost]);

  return (
    <div className={classes["blog-post"]}>
      <h2 className={classes["blog-post__title"]}>
        {blogPost && formatTitle(blogPost.title.rendered)}
      </h2>
      <p>
        By Goopter /{" "}
        <span className={classes["blog-post__date"]}>Posted on {dispDate}</span>
      </p>
      <div className={`${classes["blog-post__content-wrapper"]}`}>
        <div
          dangerouslySetInnerHTML={{
            __html: blogPost ? blogPost.content.rendered : "",
          }}
        ></div>
      </div>
    </div>
  );
};

export default BlogPostContent;
